export default (clientHttp, apiVersion) => ({
  read() {
    return clientHttp.get(`${apiVersion}/user/client_houses`, {
      params: {
        page: 'all',
      },
    })
  },
})
